/**
 * Helpers for the "Add via link" panel in the Board Editor.
 *
 * Kept tiny and pure so the Board Editor itself doesn't have to think about
 * URL parsing — the UI just receives a parsed array and renders previews.
 */

const VALID_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif'];

export const validateImageUrl = (url) => {
  const urlLower = url.toLowerCase().split('?')[0];
  return VALID_IMAGE_EXTENSIONS.some((ext) => urlLower.endsWith(ext));
};

/**
 * Split a pasted text blob into one URL per line and tag each line with a
 * validity verdict so the panel can render the preview / "invalid" list
 * without a second pass.
 */
export const parseExternalUrls = (text) => {
  const lines = text
    .split(/[\n\r]+/)
    .map((line) => line.trim())
    .filter(Boolean);

  return lines.map((line) => {
    const isValid = validateImageUrl(line);
    return {
      url: line,
      valid: isValid,
      preview: isValid ? line : null,
      error: isValid ? null : 'Invalid image URL',
    };
  });
};
